import styled from "styled-components";

/**
 * Shared styled-components for mweb page shells (Listing, TravellerDetails, etc.).
 * Import these instead of duplicating across page-level Styles.ts.
 */

export const MwebPageRoot = styled.div`
  max-width: 480px;
  margin: 0 auto;
  min-height: 100vh;
  background: #f2f2f2;
  position: relative;
  font-family: "Lato", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
`;

export const MwebScrollArea = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
`;

export const MwebListContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 0 24px;
`;

export const MwebLoaderWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
`;

export const MwebSpinner = styled.div`
  width: 36px;
  height: 36px;
  border: 3px solid #e5e5e5;
  border-top-color: #008cff;
  border-radius: 50%;
  animation: mweb-spin 0.7s linear infinite;

  @keyframes mweb-spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const MwebOverlayLoader = styled.div`
  position: fixed;
  inset: 0;
  max-width: 480px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
  pointer-events: all;
`;
